export default {
  form: {
    versions: {
      label: 'Versio',
      placeholder: 'Valitse versio',
    },
    font_family: {
      label: 'Fontti',
    },
    background_color: {
      label: 'Taustaväri',
    },
    promo_frame_primary_color: {
      label: 'Tarjouskehyksen väri',
    },
    promo_frame_discount_label_color: {
      label: 'Tarjouskehyksen alennuksen väri',
    },
    vip_members_cta_color: {
      label: 'VIP-jäsenten CTA-väri',
    },
    url_cta_color: {
      label: 'URL-CTA:n väri',
    },
    url_color: {
      label: 'URL:n väri',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Valitse URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'QR-koodin reunan väri',
    },
    qr_code_background_color: {
      label: 'QR-koodin taustaväri',
    },
    footer_background_color: {
      label: 'Alatunnisteen taustaväri',
    },
    logo_zoom: {
      label: 'Logon koko',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Tarran lataaminen epäonnistui',
  },
};
